// Module
var code = "<article class=\"sw-subheader\" ng-class=\"{ 'sw-subheader--hidden': $ctrl.isSubHeaderShown }\"> <ng-transclude></ng-transclude> <span ng-click=\"$ctrl.isSubHeaderShown = !$ctrl.isSubHeaderShown\"> <sw-font-awesome name=\"times\" size=\"large\"></sw-font-awesome> </span> </article> ";
// Exports
export default code;